import React, { useEffect, useState } from 'react'
import { Box, Flex, Hide, Text, Card } from 'pcln-design-system'
import PropTypes from 'prop-types'
import DisplayPrice from '../../DisplayPrice/DisplayPrice'
import SliceTitle from '../RetailItinerary/SliceTitle'
import { ChangeButton } from './ChangeButton'

import { CardWrapper, SbsAlignColumn } from './DepartureSummary.styles'

export const DepartureSummary = ({
  stopsText,
  durationText,
  changeFlightHandler,
  sliceDetailsNode,
  className,
  isOvernight,
  price,
  isSticky,
  isMultiDestination,
  cityInfo,
}) => {
  const Wrapper = isMultiDestination ? Card : CardWrapper
  const [scrollPosition, setScrollPosition] = useState(0)
  /* istanbul ignore next */
  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const departureSummaryText = isMultiDestination ? (
    <Flex>
      <Hide xs sm pr={1}>
        Your flight from
      </Hide>
      <Box>
        {cityInfo?.originAirport} to {cityInfo?.destinationAirport}:
      </Box>
    </Flex>
  ) : (
    'Your departure flight:'
  )
  return (
    <Box data-testid='departure-summary-box'>
      <Wrapper
        color='primary.light'
        borderRadius='xl'
        borderWidth={0}
        isSticky={isSticky}
        data-testid='departure-summary-wrapper'
        scrollPosition={scrollPosition}
        isMultiDestination={isMultiDestination}
        pt={[2, 2, 2, 3]}
        px={[2, 3]}
      >
        <Flex alignItems='center' pb={[3, 3, 3, 4]}>
          <Box>
            <SliceTitle
              isOvernight={isOvernight}
              duration={durationText}
              title={stopsText}
              isDepartureSummary
              departureSummaryText={departureSummaryText}
            />
          </Box>
          <Hide lg xl xxl ml='auto'>
            <ChangeButton changeFlightHandler={changeFlightHandler} size={['small', 'small', 'medium']} />
          </Hide>
        </Flex>
        <Flex justifyContent='space-between' className={className} data-testid='departure-summary'>
          <SbsAlignColumn width={['86%', '72%']}>
            <Box width={1}>{sliceDetailsNode}</Box>
          </SbsAlignColumn>
          <Flex width={[null, null, null, '28%']} justifyContent='center' mt={2}>
            <Box>
              <DisplayPrice
                isMultiDestination={isMultiDestination}
                isDepartureSummary
                dollar={price.dollar}
                cents={price.cents}
                color='text.base'
                isResponsive
              />
              <Text color='text.light' fontSize='10px' textAlign={['right', 'center']}>
                per person
              </Text>
              {isMultiDestination ? null : (
                <Text color='text.light' fontSize='10px' textAlign={['right', 'center']}>
                  Round-Trip
                </Text>
              )}
            </Box>
          </Flex>
          <Hide xs sm md data-test-id='hide-box' mt={2}>
            <Box mr={3}>
              <ChangeButton changeFlightHandler={changeFlightHandler} />
            </Box>
          </Hide>
        </Flex>
      </Wrapper>
    </Box>
  )
}

DepartureSummary.propTypes = {
  /** Number of stops in slice */
  stopsText: PropTypes.string.isRequired,

  /** Duration of slice */
  durationText: PropTypes.string.isRequired,

  /** Callback invoked when user wants to return to Departure Tab */
  changeFlightHandler: PropTypes.func.isRequired,

  /** React node returned from `SliceDetails` component */
  sliceDetailsNode: PropTypes.node.isRequired,

  /** Boolean to show/hide overnight icon */
  isOvernight: PropTypes.bool,

  /** Price object with dollars and cents */
  price: PropTypes.shape({
    dollar: PropTypes.string,
    cents: PropTypes.string,
  }).isRequired,

  className: PropTypes.string,

  /** Designates position: sticky */
  isSticky: PropTypes.bool,

  /** Change vs Change Flight Text */
  isChangeFlightLinkVariant: PropTypes.bool,

  /** The % of page scrolled */
  scrollPosition: PropTypes.number,
  isMultiDestination: PropTypes.bool,
  cityInfo: PropTypes.shape({
    originAirport: PropTypes.string,
    destinationAirport: PropTypes.string,
  }),
}
